<div class="vid-apskaita-forma-style">
  <div class="mb-2">
    <h4><strong>{{header}}</strong></h4>
  </div>
  <kendo-tabstrip *ngIf="giiAtaskaitaApi">
    <kendo-tabstrip-tab title="{{ 'title.busenu.istorija' | translate }}">
      <ng-template kendoTabContent class="row">
        <div class="col">
          <div>
            <div style="display: flex; align-items: center; justify-content: space-between;">
              <label class="title">{{ 'title.busenu.istorija' | translate }}</label>
              <button kendoButton themeColor="primary" fillMode="outline" (click)="this.printGrid()" [disabled]="this.isPrinting">
                {{ 'button.print' | translate }}
              </button>
            </div>
            <hr class="hr-under-line">
            <kendo-grid [data]="busenuIstorija"
                        [kendoGridBinding]="busenuIstorija"
                        (cellClick)="onRowSelect($event.dataItem)"
                        [height]="300"
                        [class]="'selectable-grid'"
                        [selectable]="true"
                        [sortable]="true"
                        [sort]="[{ field: 'koregData', dir: 'desc' }]">
              <kendo-grid-column field="koregData" title="{{ 'grid.title.data.ir.laikas' | translate }}" [width]="15">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ dataItem.koregData | date: 'yyyy-MM-dd HH:mm' }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="senaBusena" title="{{ 'grid.title.buvusi.busena' | translate }}" [width]="15">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{
                    dataItem.senaBusena !== null ? ('enum.ataskaitosBusena.' + dataItem.senaBusena | translate) : '-'
                  }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="busena" title="{{ 'grid.title.nauja.busena' | translate }}" [width]="15">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{ 'enum.ataskaitosBusena.' + dataItem.busena | translate}}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="koregPriezastis" title="{{ 'grid.title.duomenu.koreg.priezastis' | translate }}" [width]="35">
                <ng-template kendoGridCellTemplate let-dataItem>
                  {{
                  isEnumValue(dataItem.koregPriezastis)
                    ? ('label.koreg.' + dataItem.koregPriezastis | translate)
                    : dataItem.koregPriezastis
                  }}
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="koregAsmuo" title="{{ 'grid.title.naudotojas.pakeites.busena' | translate }}" [width]="20"> </kendo-grid-column>
              <kendo-grid-messages
                      [noRecords]="'label.sarasas.tuscias' | translate">
              </kendo-grid-messages>
            </kendo-grid>
          </div>
        </div>
        <div style="padding-top: 10px" class="col" *ngIf="isRowSelected">
          <label class="title">{{ 'title.duomenu.pakeitimo.istorija' | translate }}</label>
          <hr class="hr-under-line">
          <kendo-grid [data]="selectedRow.giiAtaskIstorijaApiList">
            <kendo-grid-column field="tipas" title="{{ 'grid.title.tipas' | translate }}" [width]="20">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ translateClassifierLabel(dataItem.tipas) }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="veiklosBudas" title="{{ 'grid.title.veiklosBudas' | translate }}" [width]="20">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ translateClassifierLabel(dataItem.veiklosBudas) }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="laukoPav" title="{{ 'grid.title.lauko.pavadinimas' | translate }}" [width]="20">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{ dataItem.laukoPav | translate }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="senaReiksme" title="{{ 'grid.title.buvusi.reiksme' | translate }}" [width]="15">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{
                  dataItem.senaReiksme !== null ? (dataItem.senaReiksme) : '-'
                }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="naujaReiksme" title="{{ 'grid.title.nauja.reiksme' | translate }}" [width]="15">
              <ng-template kendoGridCellTemplate let-dataItem>
                {{
                  dataItem.naujaReiksme !== null ? dataItem.naujaReiksme : '-'
                }}
              </ng-template>
            </kendo-grid-column>
            <kendo-grid-messages
                    [noRecords]="'label.sarasas.tuscias' | translate"></kendo-grid-messages>
          </kendo-grid>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="{{ 'apskaita.title.ataskaitosPerziura' | translate }}" [selected]="true">
      <ng-template kendoTabContent>
        <div class="tab-content-wrapper">
          <ng-container *ngIf="sharedDataService.getIsLoading() | async; else showAtaskPerziura">
            <div class="k-loading-mask">
              <div class="k-loading-image"></div>
            </div>
          </ng-container>
          <ng-template kendoTabContent #showAtaskPerziura>
            <div>
              <atask-perziura [data]="giiAtaskaitaApi" [giiRegistracijaApi]="giiRegistracijaApi" [klasifikatoriusList]="klasifikatoriusList"></atask-perziura>
            </div>
          </ng-template>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
    <kendo-tabstrip-tab title="{{ 'apskaita.title.patikrinimoDuomenys' | translate }}">
      <ng-template kendoTabContent>
        <div class="content">
          <div class="button-row">
            <kendo-button kendoButton themeColor="primary" fillMode="outline" (click)="onTikrintinaClicked()" [disabled]="!enableTikrintinaButton()">
              {{ 'button.tikrintina' | translate }}
            </kendo-button>
            <kendo-button kendoButton themeColor="primary" fillMode="outline" (click)="onNeTikrintinaClicked()" [disabled]="!enableNeTikrintinaButton()">
              {{ 'button.netikrintina' | translate }}
            </kendo-button>
            <kendo-button kendoButton themeColor="primary" fillMode="outline" (click)="onpradetiTikrinimaClicked()" [disabled]="!enablePradetiTikrinimaButton()">
              {{ 'button.pradetiTikrinima' | translate }}
            </kendo-button>
            <kendo-button kendoButton themeColor="primary" fillMode="outline" (click)="onTikrinimoDuomenysClicked()" [disabled]="!enableTikrinimoDuomenysButton()">
              {{ 'button.tikrinimoDuomenys' | translate }}
            </kendo-button>
            <kendo-button kendoButton themeColor="primary" fillMode="outline" (click)="onPatikrintaClicked()" [disabled]="!enablePatikrintaButton()">
              {{ 'button.patikrinta' | translate }}
            </kendo-button>
            <kendo-button kendoButton themeColor="primary" fillMode="outline" (click)="onAtmestiClicked()" [disabled]="!enableAtmestiButton()">
              {{ 'button.atmesti' | translate }}
            </kendo-button>
            <kendo-button kendoButton themeColor="primary" fillMode="outline" (click)="onPriskirtiClicked()">
              {{ 'button.priskirtiAsmeni' | translate }}
            </kendo-button>
          </div>
          <div class="row">
            <div class="col-3">
              <label class="label">{{ 'apskaita.tikrinimoDuomenys.atsakingasUz' | translate }}</label>
            </div>
            <div class="col-3">
              {{ giiAtaskaitaApi.atsakingasVertinimas == 'tikrinimas'
              ? (('label.' + giiAtaskaitaApi.atsakingasVertinimas) | translate:{
                srautas: ('label.srautas.daugiskaita.' + rowData.srautoKodas) | translate
              })
                : giiAtaskaitaApi.atsakingasVertinimas
              }}
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div>
                <label class="title">{{ 'apskaita.title.patikrinimoDuomenys' | translate }}</label>
                <hr class="hr-under-line mb-2">
                <kendo-grid [data]="giiAtaskVertinimasList"
                            [kendoGridBinding]="giiAtaskVertinimasList"
                            [height]="300"
                            [sortable]="true"
                            [sort]="[{ field: 'vertinimoData', dir: 'desc' }]">
                  <kendo-grid-column field="vertinimoData" title="{{ 'apskaita.tikrinimoDuomenys.dataIrLaikas' | translate }}" [width]="15">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.vertinimoData | date: 'yyyy-MM-dd HH:mm' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="senaBusena" title="{{ 'apskaita.tikrinimoDuomenys.senaBusena' | translate }}" [width]="15">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{
                        dataItem.senaBusena !== null ? ('enum.vidineAtaskaitosBusena.' + dataItem.senaBusena | translate) : '-'
                      }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="busena" title="{{ 'apskaita.tikrinimoDuomenys.naujaBusena' | translate }}" [width]="15">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ 'enum.vidineAtaskaitosBusena.' + dataItem.busena | translate}}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="atmetimoPriezastis" title="{{ 'apskaita.tikrinimoDuomenys.atmetimoPriezastis' | translate }}" [width]="10"></kendo-grid-column>
                  <kendo-grid-column field="tikslinimoTerminas" title="{{ 'apskaita.tikrinimoDuomenys.tikslinimoTerminas' | translate }}" [width]="15">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      {{ dataItem.tikslinimoTerminas | date: 'yyyy-MM-dd' }}
                    </ng-template>
                  </kendo-grid-column>
                  <kendo-grid-column field="insertUser" title="{{ 'apskaita.tikrinimoDuomenys.busenosPakeitejas' | translate }}" [width]="20"></kendo-grid-column>
                  <kendo-grid-column field="subjektasKomentaras" title="{{ 'apskaita.tikrinimoDuomenys.komentarasSubjektui' | translate }}" [width]="20"></kendo-grid-column>
                  <kendo-grid-column field="vidinisKomentaras" title="{{ 'apskaita.tikrinimoDuomenys.vidinisKomentaras' | translate }}" [width]="20"></kendo-grid-column>
                  <kendo-grid-messages
                          [noRecords]="'label.sarasas.tuscias' | translate">
                  </kendo-grid-messages>
                </kendo-grid>
              </div>
            </div>
          </div>
        </div>
      </ng-template>
    </kendo-tabstrip-tab>
  </kendo-tabstrip>
  <kendo-dialog
          title="{{'button.pradetiTikrinima' | translate}}"
          *ngIf="pradetiTikrinimaConfirmOpened"
          (close)="pradetiTikrinimaConfirmclose()"
          [minWidth]="250"
          [width]="450"
  >
    <p style="margin: 30px; text-align: center;">
      {{'apskaita.dialog.arTikraiVykdyti' | translate}}
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="pradetiTikrinimaConfirmclose()">{{'button.ne' | translate}}</button>
      <button kendoButton (click)="onpradetiTikrinimaConfirmClicked()" themeColor="primary">{{'button.taip' | translate}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <kendo-dialog
          title="{{'button.patikrinta' | translate}}"
          *ngIf="patikrintaConfirmOpened"
          (close)="patikrintaConfirmClose()"
          [minWidth]="250"
          [width]="450"
  >
    <p style="margin: 30px; text-align: center;">
      {{'apskaita.dialog.arTikraiVykdyti' | translate}}
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="patikrintaConfirmClose()">{{'button.ne' | translate}}</button>
      <button kendoButton (click)="onPatikrintaConfirmClicked()" themeColor="primary">{{'button.taip' | translate}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <kendo-dialog
          *ngIf="tikrinimoDuomenysOpened"
          (close)="tikrinimoDuomenysConfirmClose()"
          [minWidth]="250"
          [width]="450"
  >
    <kendo-label [for]="komentarasSubjektas" text="{{ 'apskaita.tikrinimoDuomenys.komentarasSubjektui' | translate }}"></kendo-label>
    <kendo-textbox
        #komentarasSubjektas
        [clearButton]="true"
        [(ngModel)]="tikrinimoDuomenys.subjektasKomentaras"
    ></kendo-textbox>
    <kendo-label [for]="vidinisKomentaras" text="{{ 'apskaita.tikrinimoDuomenys.vidinisKomentaras' | translate }}"></kendo-label>
    <kendo-textbox
        #vidinisKomentaras
        [clearButton]="true"
        [(ngModel)]="tikrinimoDuomenys.vidinisKomentaras"
    ></kendo-textbox>
    <kendo-dialog-actions>
      <kendo-button kendoButton themeColor="primary" (click)="onTikrinimoDuomenysConfirmClicked()">
        {{ 'button.gerai' | translate }}
      </kendo-button>
      <kendo-button kendoButton themeColor="primary" fillMode="outline" style="margin-right: 10px;" (click)="tikrinimoDuomenysConfirmClose()">
        {{ 'button.uzdaryti' | translate }}
      </kendo-button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <kendo-dialog
          *ngIf="atmestiOpened"
          (close)="atmestiConfirmClose()"
          [minWidth]="250"
          [width]="450"
  >
    <form class="k-form k-form-md mb-5" >
      <ng-container [formGroup]="ataskKurimoGroup">
        <kendo-formfield>
          <kendo-label [for]="atmetimoPriezastys" text="{{ 'apskaita.tikrinimoDuomenys.atmetimoPriezastys' | translate }}" class="required-field"></kendo-label>
          <kendo-textbox
              #atmetimoPriezastys
              formControlName="priezastys"
              [clearButton]="true"
              [(value)]="atmestiDuomenys.atmetimoPriezastis"
          ></kendo-textbox>
          <kendo-formerror>
            {{ 'validator.required' | translate }}
          </kendo-formerror>
        </kendo-formfield>
        <kendo-formfield>
          <kendo-label [for]="tikslinimoTerminas" text="{{ 'apskaita.tikrinimoDuomenys.tikslinimoTerminas' | translate }}" class="required-field"></kendo-label>
          <kendo-datepicker placeholder=""
                            format="yyyy-MM-dd"
                            [format]="'yyyy-MM-dd'"
                            [(ngModel)]="atmestiDuomenys.tikslinimoTerminas"
                            #tikslinimoTerminas
                            formControlName="terminas">
            <kendo-datepicker-messages
                    today="{{ 'label.siandien' | translate }}"
                    toggle="{{ 'label.isskleisti.kalendoriu' | translate }}"
            ></kendo-datepicker-messages>
          </kendo-datepicker>
          <kendo-formerror>
            {{ 'validator.required' | translate }}
          </kendo-formerror>
        </kendo-formfield>
      </ng-container>
    </form>
    <kendo-dialog-actions>
      <kendo-button kendoButton themeColor="primary" (click)="onAtmestiConfirmClicked()">
        {{ 'button.atmesti' | translate }}
      </kendo-button>
      <kendo-button kendoButton themeColor="primary" fillMode="outline" style="margin-right: 10px;" (click)="atmestiConfirmClose()">
        {{ 'button.uzdaryti' | translate }}
      </kendo-button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <kendo-dialog
          title="{{'button.priskirtiAsmeni' | translate}}"
          *ngIf="priskirtiAsmeniOpened"
          (close)="priskirtiAsmeniClose()"
          [minWidth]="250"
          [width]="450"
  >
    <kendo-label [for]="asmenysList" text="{{ 'apskaita.tikrinimoDuomenys.atsakingasAsmuo' | translate }}" class="required-field"></kendo-label>
    <kendo-dropdownlist
        #asmenysList
        [data]="asmenys"
        [filterable]="true"
        [textField]="'pavadinimas'"
        [valueField]="'pavadinimas'"
        [(ngModel)]="pasirinktasAsmuo"
        [valuePrimitive]="true"
        (filterChange)="onFilterChange($event)">
    </kendo-dropdownlist>
    <kendo-dialog-actions>
      <button kendoButton *ngIf="pasirinktasAsmuo" (click)="onPriskirtiConfirmClicked()" themeColor="primary">{{'button.priskirti' | translate}}</button>
      <button kendoButton (click)="priskirtiAsmeniClose()">{{'button.atsaukti' | translate}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
  <kendo-dialog
          title="{{'button.atmesti' | translate}}"
          *ngIf="atmestiConfirmOpened"
          (close)="atmestiDialogConfirmClose()"
          [minWidth]="250"
          [width]="450"
  >
    <p style="margin: 30px; text-align: center;">
      {{ 'apskaita.dialog.arTikraiAtmesti' | translate:{
            srautas: ('label.srautas.daugiskaita.maz.' + rowData.srautoKodas) | translate
        }
      }}
    </p>
    <kendo-dialog-actions>
      <button kendoButton (click)="atmestiDialogConfirmClose()">{{'button.ne' | translate}}</button>
      <button kendoButton (click)="onAtmestiDialogConfirmClicked()" themeColor="primary">{{'button.taip' | translate}}</button>
    </kendo-dialog-actions>
  </kendo-dialog>
</div>
<div class="pdf-hidden" *ngIf="loadPdf">
  <kendo-pdf-export
    #pdfExport
    [landscape]="true"
    [scale]="0.7"
    [paperSize]="'A4'"
    [margin]="20"
  >
    <div *ngFor="let row of busenuIstorija" class="pdf-section">
      <h3>{{ 'title.busenu.istorija' | translate }}</h3>

      <table class="pdf-table">
        <thead>
        <tr>
          <th>{{ 'grid.title.data.ir.laikas' | translate }}</th>
          <th>{{ 'grid.title.buvusi.busena' | translate }}</th>
          <th>{{ 'grid.title.nauja.busena' | translate }}</th>
          <th>{{ 'grid.title.duomenu.koreg.priezastis' | translate }}</th>
          <th>{{ 'grid.title.naudotojas.pakeites.busena' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td>{{ row.koregData | date: 'yyyy-MM-dd HH:mm' }}</td>
          <td>
            {{
            row.senaBusena !== null
              ? ('enum.ataskaitosBusena.' + row.senaBusena | translate)
              : '-'
            }}
          </td>
          <td>{{ 'enum.ataskaitosBusena.' + row.busena | translate }}</td>
          <td class="wrap-text">
            {{
            isEnumValue(row.koregPriezastis)
              ? ('label.koreg.' + row.koregPriezastis | translate)
              : row.koregPriezastis
            }}
          </td>
          <td>{{ row.koregAsmuo }}</td>
        </tr>
        </tbody>
      </table>

      <div *ngIf="row.giiAtaskIstorijaApiList?.length">
        <h4>{{ 'title.duomenu.pakeitimo.istorija' | translate }}</h4>

        <table class="pdf-table">
          <thead>
          <tr>
            <th>{{ 'grid.title.tipas' | translate }}</th>
            <th>{{ 'grid.title.veiklosBudas' | translate }}</th>
            <th>{{ 'grid.title.lauko.pavadinimas' | translate }}</th>
            <th>{{ 'grid.title.buvusi.reiksme' | translate }}</th>
            <th>{{ 'grid.title.nauja.reiksme' | translate }}</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let item of row.giiAtaskIstorijaApiList">
            <td>{{ translateClassifierLabel(item.tipas) }}</td>
            <td>{{ translateClassifierLabel(item.veiklosBudas) }}</td>
            <td>{{ item.laukoPav | translate }}</td>
            <td>{{ item.senaReiksme !== null ? item.senaReiksme : '-' }}</td>
            <td>{{ item.naujaReiksme !== null ? item.naujaReiksme : '-' }}</td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </kendo-pdf-export>
</div>
